import availability from './availability'
import list from './list'
import logs from './logs'
import notes from './notes'
import payoutForm from './payout-form'
import reservations from './reservations'
import reviews from './reviews'
import shiftForm from './shift-form'
import userInfo from './user-info'
import admin from './admin'

let sharedMutations = []
// sharedMutations = sharedMutations.concat(availability.sharedMutations)
sharedMutations = sharedMutations.concat(list.sharedMutations)
sharedMutations = sharedMutations.concat(notes.sharedMutations)
sharedMutations = sharedMutations.concat(reservations.sharedMutations)
sharedMutations = sharedMutations.concat(reviews.sharedMutations)
sharedMutations = sharedMutations.concat(userInfo.sharedMutations)

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    admin.state,
    availability.state,
    list.state,
    logs.state,
    notes.state,
    payoutForm.state,
    reservations.state,
    reviews.state,
    shiftForm.state,
    userInfo.state
  ),
  mutations: Object.assign(
    admin.mutations,
    availability.mutations,
    list.mutations,
    logs.mutations,
    notes.mutations,
    payoutForm.mutations,
    reservations.mutations,
    reviews.mutations,
    shiftForm.mutations,
    userInfo.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/provider/index.js